export const GET_DAILY_WEATHER_START = "GET_DAILY_WEATHER_START";
export const GET_DAILY_WEATHER_SUCC = "GET_DAILY_WEATHER_SUCC";
export const GET_DAILY_WEATHER_FAIL = "GET_DAILY_WEATHER_FAIL";
